module.exports = __webpack_public_path__ + "img/cabinet_alerts.3ddd2eba.svg";